// Widget constants and magic numbers documentation

// Image dimensions (from Figma design specifications)
export const WIDGET_IMAGE_SIZE = {
  WIDTH: 85, // 85px as specified in Figma
  HEIGHT: 85, // 85px as specified in Figma
  BORDER_RADIUS: 6, // 6px as specified in Figma
} as const;

// Tailwind custom spacing mapping
export const TAILWIND_SPACING = {
  /** 85px - Widget image size from Figma */
  "26": "85px",
} as const;

// Widget UI constants
export const WIDGET_DEFAULTS = {
  POSTS_LIMIT: 4,
  INTERSECTION_THRESHOLD: 0.5, // 50% visibility threshold for analytics
  FALLBACK_THEME: {
    primaryColor: "#333",
    blueColor: "#0066cc",
  },
} as const;

// API endpoints
export const API_ENDPOINTS = {
  BASE_URL: "https://voltax-search-service.mmsport.voltaxservices.io",
  RECOMMENDATIONS: "/recommendations",
  BLUECONIC_RECOMMENDATIONS: "/bc-recommendations",
  ANALYTICS: "https://eventer-widget.bqstreamer.com/tr",
} as const;

// Analytics constants
export const ANALYTICS = {
  MAX_PAYLOAD_SIZE: 8192, // 8KB limit for sendBeacon
  WIDGET_TARGET: "voltax_recirculation",
  WIDGET_TYPE: "widget",
  WIDGET_VERSION: "1.0",
} as const;

// Accessibility constants
export const A11Y = {
  SCREEN_READER_ONLY: "rw-sr-only",
  FOCUS_RING: "rw-ring-2 rw-ring-blue rw-ring-offset-2",
} as const;
